/**
 * @generated SignedSource<<b4f4ee2f5f02cf2512029b9614981638>>
 * @relayHash 630090fa5cf5bcfeddd01162012ff4f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 339b3ba600f0cc611331f8b0a730bb0799584a10cda78023fc073b9961235a26

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useUpdateContentPropertyPageDeleteMutation$variables = {
  pageId: string;
  propertyKey: string;
};
export type useUpdateContentPropertyPageDeleteMutation$data = {
  readonly confluence: {
    readonly deletePageProperty: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useUpdateContentPropertyPageDeleteMutation = {
  response: useUpdateContentPropertyPageDeleteMutation$data;
  variables: useUpdateContentPropertyPageDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = [
  {
    "concreteType": "ConfluenceMutationApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "propertyKey"
              },
              {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "pageId"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "ConfluenceDeletePagePropertyPayload",
        "kind": "LinkedField",
        "name": "deletePageProperty",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateContentPropertyPageDeleteMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateContentPropertyPageDeleteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "630090fa5cf5bcfeddd01162012ff4f3",
    "id": "339b3ba600f0cc611331f8b0a730bb0799584a10cda78023fc073b9961235a26",
    "metadata": {},
    "name": "useUpdateContentPropertyPageDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateContentPropertyPageDeleteMutation($propertyKey:String!,$pageId:ID!){confluence{deletePageProperty(input:{key:$propertyKey,pageId:$pageId}){success}}}"
  }
};
})();

(node as any).hash = "3ec33a745a7e32de2475af6c3816f0ad";

export default node;
